import type { QueryClient } from "@tanstack/react-query";
import { createRouter, type RouterHistory } from "@tanstack/react-router";

import { routeTree } from "@/routeTree.gen";

import { RouteError } from "./error-boundary";
import { NotFound } from "./not-found";

export interface RouterContext {
  queryClient: QueryClient;
}

export function makeRouter(queryClient: QueryClient, history?: RouterHistory) {
  return createRouter({
    routeTree,
    history,
    context: { queryClient },
    defaultPreload: "intent",
    defaultPreloadStaleTime: 0,
    scrollRestoration: true,
    defaultErrorComponent: RouteError,
    defaultNotFoundComponent: NotFound,
    // Invalid search params fall back to defaults in each route's validateSearch, so a parse
    // error never surfaces as a page error.
    defaultStructuralSharing: true,
  });
}

export type AppRouter = ReturnType<typeof makeRouter>;

declare module "@tanstack/react-router" {
  interface Register {
    router: AppRouter;
  }
}
